import type { FaireProductEntity } from "../../entity_types/product";

export const p_fhnfb6dbpx: FaireProductEntity = {
  token: "p_fhnfb6dbpx",
  type: "product",
  name: "Teddy Bear Planter",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/e8fe2c0c7c3e58b66defc2a22afe4360baf8b30a781ab0ffe578e4c1377e87b8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/399f49884fcc3d80f238d995d0b47bb39f1a90871ee59070fcea89c1e4f28815.jpeg",
    "https://cdn.faire.com/fastly/1df4f91ea2bcbae87c28cdd19d44877c2d06606191324472f6a7428ea701ef73.jpeg",
    "https://cdn.faire.com/fastly/78cc53d72a0ce476219e34bdeed17b0bad48262b48fc9e21791c24e54700e6ff.jpeg",
    "https://cdn.faire.com/fastly/16710896ba70b1c08de41b55f1ca475838898da1ca237cae0ab767e66dbfa3b1.jpeg"
  ],
  priceDollars: 3,
  description: "A ceramic planter from our Teddy Bear Collection displaying a cute teddy bear inspired design with painted details and gloss finish. Our Teddy Bear planter features opening on top to place plants or small décor. Greenery pictured not included. A teddy bear themed plant accessory with a variety of display options.",
  tags: [],
  msrpDollars: 5.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:41.053Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
